module.exports = __webpack_public_path__ + "img/copy-red.2ea956d4.svg";